import React from "react";
import { ComingSoon } from "components/common";

const CreateGraph = () => {
  return (
    <ComingSoon
      title="Analytics"
      description="Advanced data visualization and analytics tools are being developed!"
      icon="MdPieChart"
    />
  );
};

export default CreateGraph;
